import { render, staticRenderFns } from "./SupportMenuItem.vue?vue&type=template&id=35f122f4"
import script from "./SupportMenuItem.vue?vue&type=script&lang=js"
export * from "./SupportMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports